import { render, staticRenderFns } from "./SystemParameter.vue?vue&type=template&id=133b0ca9&scoped=true&"
import script from "./SystemParameter.vue?vue&type=script&lang=js&"
export * from "./SystemParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b0ca9",
  null
  
)

export default component.exports